import { useSearchParams } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

import CampaignTabs from './CampaignTabs'
import CampaignAccordion from './CampaignAccordion'
import CampaignPartners from './CampaignPartners'
import Card from '../ui/Card/Card'

import useIsMobile from '../../hooks/useIsMobile'
import styles from './Campaign.module.scss'
import Image from '../ui/Image/Image'
import { getImageUrl } from '../../utils'

const CampaignTabsAccordion = ({ tabs, slug, avoidRtl }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  let tabParam = searchParams?.get('tab')
  const [selectedTab, setSelectedTab] = useState()
  const wrapperRef = useRef(null)
  const isMobile = useIsMobile()

  useEffect(() => {
    let defaultTab = tabs?.[0]
    if (tabParam) {
      const foundTab = tabs?.find((tab) => tab?.countrycode === tabParam)
      defaultTab = foundTab || tabs?.[0]
    }
    setSelectedTab(defaultTab)
  }, [tabs, tabParam])

  useEffect(() => {
    if (tabParam) {
      const foundTabIndex = tabs?.findIndex(
        (tab) => tab?.countrycode === tabParam
      )
      const wrapperRect = wrapperRef?.current?.getBoundingClientRect()
      let scrollVal =
        wrapperRect?.top +
        window?.scrollY -
        (isMobile ? 80 : 110) +
        (isMobile ? foundTabIndex * 80 : 0)
      setTimeout(() => {
        window.scrollTo({
          top: scrollVal,
          behavior: 'smooth',
        })
      }, 500)
    }
  }, [tabParam])

  const tabClickHandler = (tab) => {
    setSearchParams({ tab: tab?.countrycode })
  }

  const renderPartners = () => {
    return <CampaignPartners sectiondata={selectedTab?.camp_partnerlists} />
  }

  return (
    <>
      {tabs && tabs?.length ? (
        <>
          <div className={classNames(styles.mobileFlagBtns)}>
            {tabs?.map((tab) => (
              <Card
                key={tab.country_name + tab?.countrycode}
                className={classNames(styles.cardHolder, {
                  [styles.active]:
                    tab?.countrycode === selectedTab?.countrycode,
                })}
                onClickHandler={() => {
                  tabClickHandler(tab)
                }}
              >
                {tab?.country_logo && (
                  <Image
                    className={styles.tabIcon}
                    src={getImageUrl(tab.country_logo)}
                    alt={tab?.country_logo?.alternativeText}
                  />
                )}
                <span>{tab.country_name}</span>
              </Card>
            ))}
          </div>
          <div id="wrapperRef" ref={wrapperRef}>
            <CampaignTabs
              tabs={tabs}
              selectedTab={selectedTab}
              onTabClick={tabClickHandler}
              avoidRtl={avoidRtl}
            >
              {renderPartners()}
            </CampaignTabs>
            <CampaignAccordion
              tabs={tabs}
              selectedTab={selectedTab}
              onTabClick={tabClickHandler}
            >
              {renderPartners()}
            </CampaignAccordion>
          </div>
        </>
      ) : null}
    </>
  )
}

export default CampaignTabsAccordion
